import React from "react"
import { FormPageProps } from "../../.."
import { Grid, Typography } from "@mui/material"
import FileUploader from "../../../../../pages/Projects/features/RaiseTicketForm/common/FileUploader/FileUploader"
import MuiTextField from "../../../../MuiTextField"
import MuiAutoComplete from "../../../../MuiAutocomplete"
import useEvInfra from "./useEvInfra"

const EvInfraProjectDetails = (props: FormPageProps) => {
    const { dealDoneByUsersOptions, formik, isOutright, isLoading, handleAssignToMe } = useEvInfra(props)

    return (
        <>
            <div className="project_details_container mb-16">
                <Grid container spacing={2}>
                    <Grid size={6} display="flex" flexDirection="column" gap={1}>
                        <Typography variant="label">Project Name*</Typography>
                        <MuiTextField
                            sx={{
                                height: "32px",
                            }}
                            name="project_name"
                            placeholder="Enter Project Name"
                            value={formik.values.project_name}
                            onChange={(e: any) => {
                                formik.setFieldValue("project_name", e.target?.value)
                            }}
                            error={formik.submitCount > 0 && !!formik.errors.project_name}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="label">Business POC*</Typography>
                        <MuiAutoComplete
                            sx={{
                                height: "32px !important",
                            }}
                            placeholder="Select Name"
                            options={dealDoneByUsersOptions || []}
                            value={formik.values.business_poc?.id ? formik.values.business_poc : null}
                            onChange={value => formik.setFieldValue("business_poc", value)}
                            error={formik.submitCount > 0 && !!formik.errors.business_poc}
                        />

                        <span
                            className="color-blue text-xs text-underline pl-4 cursor-pointer"
                            onClick={handleAssignToMe}>
                            Assign to me
                        </span>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="label">Upload Electricity Bill*</Typography>
                        <FileUploader
                            name="electricity_bill"
                            size="md"
                            onChange={val => {
                                formik.setFieldValue("electricity_bill", val)
                            }}
                            title="Upload File"
                            uploadedCount={formik.values.electricity_bill?.length || 0}
                            total={1}
                            error={!!formik.errors.electricity_bill}
                            showError={formik.submitCount > 0}
                            multiple={false}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="label">Upload Property Paper*</Typography>
                        <FileUploader
                            name="propery_paper"
                            size="md"
                            onChange={val => {
                                formik.setFieldValue("property_ownership_proof", val)
                            }}
                            title="Upload File"
                            uploadedCount={formik.values.property_ownership_proof?.length || 0}
                            total={1}
                            error={!!formik.errors.property_ownership_proof}
                            showError={formik.submitCount > 0}
                            multiple={false}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="label">Upload Other Documents*</Typography>
                        <FileUploader
                            name="other_documents"
                            size="md"
                            onChange={val => {
                                formik.setFieldValue("deal_docs", val)
                            }}
                            title="Upload File"
                            uploadedCount={formik.values.deal_docs?.length || 0}
                            total={3}
                            error={!!formik.errors.deal_docs}
                            showError={formik.submitCount > 0}
                            multiple={true}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="label">Upload NOC*</Typography>
                        <FileUploader
                            name="noc"
                            size="md"
                            onChange={val => {
                                formik.setFieldValue("noc", val)
                            }}
                            title="Upload File"
                            uploadedCount={formik.values.noc?.length || 0}
                            total={1}
                            error={!!formik.errors.noc}
                            showError={formik.submitCount > 0}
                            multiple={false}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="label">Upload Agreement*</Typography>
                        <FileUploader
                            name="agreement"
                            size="md"
                            onChange={val => {
                                formik.setFieldValue("agreement_report", val)
                            }}
                            title="Upload File"
                            uploadedCount={formik.values.agreement_report?.length || 0}
                            total={3}
                            error={!!formik.errors.agreement_report}
                            showError={formik.submitCount > 0}
                            multiple={false}
                        />
                    </Grid>
                    {isOutright && (
                        <Grid size={6}>
                            <Typography variant="label">Upload PO*</Typography>
                            <FileUploader
                                name="po"
                                size="md"
                                onChange={val => {
                                    formik.setFieldValue("purchase_order", val)
                                }}
                                title="Upload File"
                                uploadedCount={formik.values.purchase_order?.length || 0}
                                total={1}
                                error={!!formik.errors.purchase_order}
                                showError={formik.submitCount > 0}
                                multiple={false}
                            />
                        </Grid>
                    )}
                </Grid>
            </div>

            <footer className="raise-ticket-form__footer mt-16">
                <button className="raise-ticket-form__footer-button cancel-btn" onClick={props.handleCloseForm}>
                    Cancel
                </button>
                <button className="raise-ticket-form__footer-button next-btn" onClick={() => formik.handleSubmit()}>
                    {isLoading ? "Submitting..." : "Submit"}
                </button>
            </footer>
        </>
    )
}

export default EvInfraProjectDetails
